import { Check, X, Minus } from "lucide-react";
import { FadeUp } from "./FadeUp";

const ROWS = [
  { label: "Indian Meals", forge: true, trainer: "minus", apps: false },
  { label: "Personalized AI Plan", forge: true, trainer: "minus", apps: false },
  { label: "Gym Workout Logger", forge: true, trainer: false, apps: "minus" },
  { label: "Daily Tracking", forge: true, trainer: false, apps: true },
  { label: "Community & PR Sharing", forge: true, trainer: false, apps: false },
  { label: "AI Physique Check-ins", forge: true, trainer: "minus", apps: false },
  { label: "Progress Reports (PDF)", forge: true, trainer: "minus", apps: false },
  { label: "Price / Month", forge: "₹499", trainer: "₹8,000+", apps: "₹1,500+" },
];

const Cell = ({ value, accent }) => {
  if (value === true) return <Check size={18} className={accent ? "text-[#C6FF3D]" : "text-[#A1A1AA]"} />;
  if (value === false) return <X size={18} className="text-[#55555a]" />;
  if (value === "minus") return <Minus size={18} className="text-[#55555a]" />;
  return <span className={accent ? "text-[#C6FF3D] font-semibold" : "text-[#A1A1AA]"}>{value}</span>;
};

export const ComparisonTable = () => (
  <section className="py-14 md:py-20 px-6 bg-[#111113]">
    <div className="max-w-4xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-10">
          FORGE VS THE REST
        </h2>
      </FadeUp>

      <FadeUp>
        <div className="overflow-x-auto rounded-[24px] border border-[#232326]" data-testid="comparison-table">
          <table className="w-full min-w-[560px] text-sm">
            <thead>
              <tr className="bg-[#141416]">
                <th className="text-left text-[#A1A1AA] font-medium px-5 py-4">Feature</th>
                <th className="text-center text-[#C6FF3D] font-display text-base px-5 py-4">FORGE</th>
                <th className="text-center text-white font-medium px-5 py-4">Personal Trainer</th>
                <th className="text-center text-white font-medium px-5 py-4">Generic Apps</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row, i) => (
                <tr key={row.label} className={i % 2 === 0 ? "bg-[#0A0A0B]" : "bg-[#0d0d0f]"}>
                  <td className="text-white px-5 py-4">{row.label}</td>
                  <td className="text-center px-5 py-4">
                    <div className="flex justify-center">
                      <Cell value={row.forge} accent />
                    </div>
                  </td>
                  <td className="text-center px-5 py-4">
                    <div className="flex justify-center">
                      <Cell value={row.trainer} />
                    </div>
                  </td>
                  <td className="text-center px-5 py-4">
                    <div className="flex justify-center">
                      <Cell value={row.apps} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </FadeUp>
    </div>
  </section>
);
